import type { Segments } from 'charts/disabled/resolutionTime';
import { isDateRangeObject, type DateRangeObject } from 'shared/types/analytics';
import type { HashMap } from 'shared/types/commonView';

function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === 'string');
}

function isHashMapBoolean(value: unknown): value is HashMap<boolean> {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  return Object.values(value).every((item) => typeof item === 'boolean');
}

function isSegment(value: unknown): value is Segments[number] {
  if (typeof value !== 'object' || value === null || !('color' in value)) {
    return false;
  }

  return typeof value.color === 'string';
}

function isSegments(value: unknown): value is Segments {
  return Array.isArray(value) && value.every(isSegment);
}

export function toRadioFilterValue(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function toCheckboxFilterValue(value: unknown): HashMap<boolean> {
  return isHashMapBoolean(value) ? value : {};
}

export function toMultiselectFilterValue(value: unknown): string[] {
  return isStringArray(value) ? value : [];
}

export function toDateRangeFilterValue(value: unknown): DateRangeObject {
  return isDateRangeObject(value) ? value : { from: '', to: '' };
}

export function toSelectFilterValue(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function toSegmentsFilterValue(value: unknown): Segments {
  return isSegments(value) ? value : [];
}
